import { NgForm } from '@angular/forms';
import { ClickElement } from './base-element';
import { ElementType } from './element-type';

export class Button extends ClickElement {
  value: string = '';
  type: string = 'button';
  ngForm: NgForm | null = null;

  constructor() {
    super();
    this.elementType = ElementType.button;
  }
}
